export const ROLES = {
  ADMIN: "admin",
  SUB_ADMIN: "subadmin",
};

export function normalizeRole(role) {
  if (!role) return null;
  const normalized = String(role).toLowerCase().trim();
  return normalized === ROLES.ADMIN || normalized === ROLES.SUB_ADMIN
    ? normalized
    : null;
}

export function hasRequiredRole(userRole, requiredRole) {
  if (!requiredRole) return true;

  const normalizedUserRole = normalizeRole(userRole);
  if (!normalizedUserRole) return false;

  const requiredRoles = Array.isArray(requiredRole)
    ? requiredRole
    : [requiredRole];

  return requiredRoles
    .map((role) => normalizeRole(role))
    .filter(Boolean)
    .includes(normalizedUserRole);
}

export function getHomeRouteByRole(role) {
  const normalized = normalizeRole(role);
  return normalized === ROLES.SUB_ADMIN ? "/customers" : "/dashboard";
}
